<script>
// import PageMenu from './PageMenu.vue';
// import titlePage from './titlePage.vue';
import PageMenu from './PageMenu.vue';
import titlePage from './TitlePage.vue';
import { mapActions, mapGetters } from 'vuex';
import config from '@/services/config';
import Catalogue from '@/services/catalogue';
import SessionTimeOut from '@/component/SessionTimeoutCounter.vue'
import request from '@/services/request'

export default {
	components: {
		PageMenu,
		titlePage,
		SessionTimeOut
	},
	data() {
		return {
			config: config,
			imageBackground: `/img/oficina.jpg`,
			catalogue: new Catalogue(),
			img_profile: ''
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		}),
		nameShow(){
			const [name] = this.authUser.name.split(' ');
			const [last_name] = this.authUser.last_name.split(' ');

			return `${name} ${last_name}`;
		}
	},
	mounted() {
		this.catalogue.get_validate_holiday();

		this.fileS3(this.authUser.profile_picture, false).then((url) => {
			this.img_profile = url;
		}).catch((error) => {
			console.error("Error al obtener la imagen de perfil:", error);
			return '';
		});
	},
	methods: {
		async postLogout() {
			try {
				let logout = await this.authLogout();
				if (logout) {
					this.$nextTick(() => {
						location.reload()
					})
				}
			} catch (error) {
				console.log(error);
			}
		},
		async fileS3(file, signature = false){
            if (!file) return null;

            try {
                let _endpointSignature = `/get_url_file/${file}/files/${signature}`;
                let { data } = await request.get(_endpointSignature);

                return data && data.url ? data.url : null;
            } catch (error) {
                console.error("Error al obtener el archivo:", error);
                throw error;  // No necesitas `Promise.reject`, solo lanza el error
            }

        },
		...mapActions({
			authLogout: 'auth/logout'
		})
	},
	created() {
		Event.$on("event-load-holidays", async () => {
			await this.catalogue.get_validate_holiday();
		});
	},
}
</script>
<template>
	<div class="wrapper">
		<SessionTimeOut />
		<!-- Navbar -->
		<nav class="main-header navbar navbar-expand navbar-white bg-dark">
			<!-- Left navbar links -->
			<ul class="navbar-nav">
				<li class="nav-item">
					<a class="nav-link" data-widget="pushmenu" href="#" role="button">
						<i class="fas fa-bars"></i></a>
				</li>
			</ul>

			<!-- Right navbar links -->
			<ul class="navbar-nav ml-auto">

				<!-- Notificaciones -->
				<li class="nav-item dropdown" v-if="catalogue.validate_holiday_num > 0">
					<a class="nav-link" data-toggle="dropdown" href="#" aria-expanded="false">
						<i class="far fa-bell"></i>
						<span class="badge badge-success navbar-badge">{{ catalogue.validate_holiday_num }}</span>
					</a>

					<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right v-holday">
						<router-link :to="{ name: 'validate_holiday', query: { id: holiday.id } }" v-show="holiday.users"
							class="dropdown-item" v-for="(holiday, index) in catalogue.validate_holiday" :key="index">
							<div class="media">
								<img v-if="holiday.users.profile_picture"
									:src="config.apiUrl + holiday.users.profile_picture" alt="User Avatar"
									class="img-size-50 mr-3 img-circle">
								<img v-else :src="require('@/assets/img/profile.png')" alt="User Avatar"
									class="img-size-50 mr-3 img-circle">
								<div class="media-body">
									<h3 class="dropdown-item-title name">
										<span
											v-if="holiday.users.name && holiday.users.name != null && holiday.users.name != 'null'">
											{{ holiday.users.name }}
										</span>
										<span
											v-if="holiday.users.last_name && holiday.users.last_name != null && holiday.users.last_name != 'null'">
											{{ holiday.users.last_name }}
										</span>
									</h3>
									<p class="text-sm">Solicito vacaciones</p>
									<p class="txt-11 mt-1 text-muted"><i class="far fa-calendar mr-1"></i> De {{
										holiday.start_date }} al {{ holiday.end_date }} </p>
								</div>
							</div>

						</router-link>
						<div class="dropdown-divider"></div>
						<router-link :to="{ name: 'validate_holiday' }" class="dropdown-item dropdown-footer"> Ir aprobar
							vacaciones </router-link>
					</div>

				</li>
				<!-- Notifications Dropdown Menu -->
				<!-- <li class="nav-item pt-2">
				</li> -->

				<li class="nav-item dropdown">
					<a class="nav-link" data-toggle="dropdown" href="#">
						{{ nameShow }} &nbsp;&nbsp;

						<img v-if="img_profile" :src="img_profile" class="img-circle" width="30px" alt="">

						<i v-else class="fa fa-user-circle" aria-hidden="true"></i>


					</a>
					<!-- <div class="dropdown-menu dropdown-menu dropdown-menu-right">
						<router-link to="/profile" class="dropdown-item">
							Mi perfil
						</router-link>
						<div class="dropdown-divider"></div>
						<a href="#" @click="postLogout" class="dropdown-item">
							<i class="fa fa-sign-out-alt" aria-hidden="true"></i> Cerrar sesión
						</a>
					</div>  -->

					<div class="dropdown-menu dropdown-menu-right user-dropdown" aria-labelledby="userMenu">

						<div class="user-header">
							<div class="user-avatar-lg">
								<img v-if="img_profile" :src="img_profile" class="img-circle" width="100%" alt="">
								<i v-else class="fa fa-user-circle" aria-hidden="true"></i>
							</div>


							
							<div>
								<div class="user-fullname">{{ nameShow }}</div>
								<!-- <div style="font-size: 10px;" :aria-label="authUser.profile.name" class="hint--left hint--rounded text-muted">{{ authUser.profile.name.slice(0, 15) }}</div> -->
								<div
								style="font-size: 10px;color: gray;"
								>
								<span :aria-label="authUser.profile.name" class="hint--left hint--rounded">
									{{ authUser.profile.name.slice(0, 25) }}
									{{ authUser.profile.name.length > 25 ? '...' : '' }}
								</span>
								</div>
							</div>
						</div>

						<hr>

						<router-link to="/profile" class="dropdown-item">
							<i class="fas fa-user mr-2"></i> Mi perfil
						</router-link>

						<!-- <a href="#" class="dropdown-item">
						<i class="fas fa-cog mr-2"></i> Configuración
						</a>

						<a href="#" class="dropdown-item">
						<i class="fas fa-credit-card mr-2"></i> Facturación
						</a> -->

						<hr>

						<a href="#" @click="postLogout" class="dropdown-item logout">
							<i class="fas fa-door-open mr-2"></i> Cerrar sesión
						</a>

					</div>
				</li>
				<!-- <li class="nav-item">
					<a class="nav-link" data-widget="fullscreen" href="#" role="button">
						<i class="fas fa-expand-arrows-alt"></i>
					</a>
				</li> -->
			</ul>
		</nav>
		<!-- /.navbar -->

		<!-- Main Sidebar Container -->
		<aside class="main-sidebar elevation-4 sidebar-dark-teal">
			<!-- Brand Logo -->
			<router-link :to="{ name: 'app-home' }" class="text-center">
				<div class="div_logo bg-gradient-light">
					<img class="sidebar-open-img" :src="require('@/assets/img/logo-horizontal-color.png')" alt="logo" style="width: 80%; ">
					<img class="sidebar-collapse-img" :src="require('@/assets/img/logo-full.png')" alt="logo" style="width: 80%; ">
				</div>
				<!-- <span class="brand-text font-weight-light"> SORIANOARIZA</span> -->
			</router-link>

			<!-- Sidebar -->
			<div class="sidebar">
				<!-- <div class="user-panel mt-3 pb-3 mb-3 d-flex">
					<div class="image">
						<img :src="`${config.BaseUrl}/assets/img/logo.png`" class="img-circle elevation-2" alt="User Image">
					</div>
					<div class="info">
						<a href="#" class="d-block">{{ authUser.name }} {{ authUser.last_name }}</a>
					</div>
				</div> -->

				<PageMenu></PageMenu>

			</div>
			<!-- /.sidebar -->
		</aside>
		<div class="content-wrapper">
			<div class="col-12">

				<!-- Main content -->
				<section class="content">
					<div class="container-fluid">
						<titlePage />
						<div class="container-fluid">
							<router-view></router-view>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>
<style scoped>
.name {

	width: 200px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.txt-11 {
	font-size: 11px !important;
}

@media only screen and (max-width: 430px) {
	.v-holday {
		left: inherit;
		right: -90px;
	}

}

/* Wrapper */
.user-menu-wrapper {
  margin-right: 20px;
}

/* Trigger */
.user-trigger {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  text-decoration: none !important;
}

.user-trigger:hover {
  background: #f5f5f5;
}

/* Avatar pequeño */
.user-avatar-sm {
  width: 40px;
  height: 40px;
  background: #6c63ff;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  font-size: 14px;
}

/* Nombre */
.user-name {
  font-weight: 600;
  color: #333;
}

/* Dropdown */
.user-dropdown {
  width: 260px;
  border-radius: 15px;
  padding: 15px;
}

/* Header dentro del dropdown */
.user-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/* Avatar grande */
.user-avatar-lg {
  width: 45px;
  height: 45px;
  
  color: white;
  border-radius: 50%;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  font-size: 16px;
}

/* Nombre completo */
.user-fullname {
  font-weight: 700;
  color: #333;
}

/* Logout */
.logout {
  color: #e74c3c !important;
  font-weight: 600;
}

</style>